export default __webpack_public_path__ + "static/media/partner-14.aa35c204.png";